import { MainV3ApiBase } from './base';
import { MembershipTokenIndexView } from '../types/membershipTokens';

export const MembershipTokenApis = {
    findAll(): Promise<MembershipTokenIndexView[]> {
        return MainV3ApiBase.appendPath('users/current/membership_tokens').get();
    },
};
